/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CompanyShipmentQuote } from "./CompanyShipmentQuote";
import {
  CompanyShipmentQuoteFromJSON,
  CompanyShipmentQuoteFromJSONTyped,
  CompanyShipmentQuoteToJSON,
  CompanyShipmentQuoteToJSONTyped,
} from "./CompanyShipmentQuote";
import type { CompanyCustomerInvoice } from "./CompanyCustomerInvoice";
import {
  CompanyCustomerInvoiceFromJSON,
  CompanyCustomerInvoiceFromJSONTyped,
  CompanyCustomerInvoiceToJSON,
  CompanyCustomerInvoiceToJSONTyped,
} from "./CompanyCustomerInvoice";

/**
 *
 * @export
 * @interface CustomerInvoiceData
 */
export interface CustomerInvoiceData {
  /**
   *
   * @type {Array<CompanyShipmentQuote>}
   * @memberof CustomerInvoiceData
   */
  shipmentsWithoutInvoices: Array<CompanyShipmentQuote>;
  /**
   *
   * @type {Array<CompanyCustomerInvoice>}
   * @memberof CustomerInvoiceData
   */
  issuedInvoices: Array<CompanyCustomerInvoice>;
  /**
   *
   * @type {Array<CompanyCustomerInvoice>}
   * @memberof CustomerInvoiceData
   */
  settlementPending: Array<CompanyCustomerInvoice>;
  /**
   *
   * @type {Array<CompanyCustomerInvoice>}
   * @memberof CustomerInvoiceData
   */
  settled: Array<CompanyCustomerInvoice>;
  /**
   *
   * @type {Array<CompanyCustomerInvoice>}
   * @memberof CustomerInvoiceData
   */
  badDebtInvoices: Array<CompanyCustomerInvoice>;
}

/**
 * Check if a given object implements the CustomerInvoiceData interface.
 */
export function instanceOfCustomerInvoiceData(
  value: object,
): value is CustomerInvoiceData {
  if (
    !("shipmentsWithoutInvoices" in value) ||
    value["shipmentsWithoutInvoices"] === undefined
  )
    return false;
  if (!("issuedInvoices" in value) || value["issuedInvoices"] === undefined)
    return false;
  if (
    !("settlementPending" in value) ||
    value["settlementPending"] === undefined
  )
    return false;
  if (!("settled" in value) || value["settled"] === undefined) return false;
  if (!("badDebtInvoices" in value) || value["badDebtInvoices"] === undefined)
    return false;
  return true;
}

export function CustomerInvoiceDataFromJSON(json: any): CustomerInvoiceData {
  return CustomerInvoiceDataFromJSONTyped(json, false);
}

export function CustomerInvoiceDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomerInvoiceData {
  if (json == null) {
    return json;
  }
  return {
    shipmentsWithoutInvoices: (
      json["shipmentsWithoutInvoices"] as Array<any>
    ).map(CompanyShipmentQuoteFromJSON),
    issuedInvoices: (json["issuedInvoices"] as Array<any>).map(
      CompanyCustomerInvoiceFromJSON,
    ),
    settlementPending: (json["settlementPending"] as Array<any>).map(
      CompanyCustomerInvoiceFromJSON,
    ),
    settled: (json["settled"] as Array<any>).map(
      CompanyCustomerInvoiceFromJSON,
    ),
    badDebtInvoices: (json["badDebtInvoices"] as Array<any>).map(
      CompanyCustomerInvoiceFromJSON,
    ),
  };
}

export function CustomerInvoiceDataToJSON(json: any): CustomerInvoiceData {
  return CustomerInvoiceDataToJSONTyped(json, false);
}

export function CustomerInvoiceDataToJSONTyped(
  value?: CustomerInvoiceData | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    shipmentsWithoutInvoices: (
      value["shipmentsWithoutInvoices"] as Array<any>
    ).map(CompanyShipmentQuoteToJSON),
    issuedInvoices: (value["issuedInvoices"] as Array<any>).map(
      CompanyCustomerInvoiceToJSON,
    ),
    settlementPending: (value["settlementPending"] as Array<any>).map(
      CompanyCustomerInvoiceToJSON,
    ),
    settled: (value["settled"] as Array<any>).map(CompanyCustomerInvoiceToJSON),
    badDebtInvoices: (value["badDebtInvoices"] as Array<any>).map(
      CompanyCustomerInvoiceToJSON,
    ),
  };
}
